export const TERMS_URL = `${
  process.env.REACT_APP_WEBSITE_URL
}/terms-of-service`;
export const PRIVACY_URL = `${process.env.REACT_APP_WEBSITE_URL}/privacy`;
export const SECURITY_URL = `${
  process.env.REACT_APP_WEBSITE_URL
}/security-measures`;
